import { render, staticRenderFns } from "./HighlightLabelMaker.vue?vue&type=template&id=af8bfcc0&scoped=true&"
import script from "./HighlightLabelMaker.vue?vue&type=script&lang=js&"
export * from "./HighlightLabelMaker.vue?vue&type=script&lang=js&"
import style0 from "./HighlightLabelMaker.vue?vue&type=style&index=0&id=af8bfcc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8bfcc0",
  null
  
)

export default component.exports